import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FilePlus } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import DocTypeCombobox, { type DocTypeOption } from '../components/DocTypeCombobox';
import { PageLoader } from '../components/PageLoader';
import { InlineError } from '../components/InlineError';

export default function DocumentLibraryPage() {
  const { authFetch, isAdmin } = useAuth();
  const [types, setTypes] = useState<DocTypeOption[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let stale = false;
    authFetch('/workspace/types')
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Failed to load document types')))
      .then((data: DocTypeOption[]) => { if (!stale) setTypes(data); })
      .catch(err => { if (!stale) { setError(err.message); setTypes([]); } });
    return () => { stale = true; };
  }, []);

  if (types === null) return <PageLoader label="Loading document types..." />;

  return (
    <div>
      <div className="pb-6 mb-6 border-b border-softgrey flex items-start justify-between gap-4">
        <div>
          <h3 className="text-lg font-semibold">Document Library</h3>
          <p className="text-sm text-coolslate mt-1">Every document type, with its source files and the sections it surfaces in.</p>
        </div>
        {isAdmin && (
          <Link
            to="/types/add"
            className="inline-flex items-center gap-1.5 px-3.5 py-2 text-sm font-medium text-white bg-brand hover:bg-brand-dark rounded-lg transition-colors shrink-0"
          >
            <FilePlus className="w-4 h-4" />
            Add document type
          </Link>
        )}
      </div>

      {error && <InlineError message={error} />}
      <DocTypeCombobox mode="library" allTypes={types} />
    </div>
  );
}
